<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <SettingsMenu></SettingsMenu>
            <b-card class="qr-page-card">
              <div class="section-head">
                <h5>My QR Code</h5>
              </div>
              <p class="lead-note">
                Anyone with the AmejPay app can scan this to send you money. It carries your
                name and account email only - no balance and no card details.
              </p>

              <div v-if="isLoading" class="text-center py-5">
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <QrCard
                v-else
                :payload="payload"
                caption="Scan QR code to receive money"
                :file-name="fileName"
                share-title="My AmejPay QR code"
              ></QrCard>
            </b-card>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import SettingsMenu from "./SettingsMenu.vue";
import QrCard from "../reuseable_components/QrCard.vue";
import { mapActions, mapState } from "vuex";
import { userPayload } from "@/utils/qrpayload";

export default {
  name: "QrCode",
  components: {
    "app-header": AppHeader,
    SettingsMenu: SettingsMenu,
    QrCard: QrCard,
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapState(["profile"]),
    payload: function () { return userPayload(this.profile); },
    fileName: function () {
      const name = String(this.payload.name || "amejpay").toLowerCase().replace(/\s+/g, "-");
      return "amejpay-qr-" + name;
    },
  },
  created() {
    this.isLoading = true;
    const vm = this;
    return this.listProfile()
      .then(function () { vm.isLoading = false; })
      .catch(function () { vm.isLoading = false; });
  },
  methods: {
    ...mapActions(["listProfile"]),
  },
};
</script>

<style scoped>
.section-head { display: flex; align-items: center; justify-content: space-between; }
.section-head h5 { font-size: 16px; font-weight: 600; margin: 0; }
.lead-note { color: #6c757d; font-size: 13px; margin: 10px 0 18px; }
</style>
